import React from "react";
import useSettings from "../hooks/useSettings";
import { THEMES } from "../constants";
import { useTranslation } from "react-i18next";

const Logo = (props) => {
  const { settings } = useSettings();
  const { t } = useTranslation();

  const dir = settings.theme === THEMES.ONE_DARK ? "dark" : "light";

  const imageUrl = `/static/images/${dir}/logo.png`;

  return (
    <img
      className='img-fluid'
      alt={t("Hydrokov")}
      src={imageUrl}
      {...props}
    />
  );
};

export default Logo;
